import React from 'react';

export function Terms() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
      
      <div className="space-y-8">
      <section>
          <h2 className="text-2xl font-semibold mb-4">1. Agreement to Terms</h2>
          <p className="text-gray-600 mb-4">
            By accessing or using AI Phone Agent, you agree to be bound by these Terms of Service.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">2. Service Description</h2>
          <p className="text-gray-600 mb-4">
            AI Phone Agent provides AI-powered phone automation services for businesses.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">3. User Obligations</h2>
          <ul className="list-disc pl-6 text-gray-600 space-y-2">
            <li>Provide accurate information</li>
            <li>Maintain security of account credentials</li>
            <li>Comply with applicable laws and regulations</li>
            <li>Not misuse or attempt to hack the service</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">4. AI Phone Agent Usage</h2>
          <p className="text-gray-600 mb-4">
            Our AI Phone Agent service is designed to assist with legitimate business communications. By using our service, you agree to:
          </p>
          <ul className="list-disc pl-6 text-gray-600 space-y-2">
            <li>Use the service for lawful business purposes only</li>
            <li>Not use the service for harassment, spam, or any illegal activities</li>
            <li>Comply with all applicable laws regarding automated calling systems</li>
            <li>Disclose to your customers when they are interacting with an AI system, as required by law</li>
            <li>Take responsibility for reviewing AI-generated communications</li>
            <li>Obtain proper consent for call recording where required by law</li>
            <li>Ensure you have the legal right to use any phone number you provide to our service</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">5. AI Limitations and Disclaimers</h2>
          <p className="text-gray-600 mb-4">
            While we strive for accuracy and high quality, you acknowledge that:
          </p>
          <ul className="list-disc pl-6 text-gray-600 space-y-2">
            <li>Our AI may occasionally produce inaccurate information or "hallucinations"</li>
            <li>The AI has limitations in understanding complex situations or nuanced contexts</li>
            <li>You remain responsible for reviewing and confirming the accuracy of AI-generated communications</li>
            <li>We do not guarantee that the AI will handle all calls perfectly or appropriately in all contexts</li>
            <li>You will monitor AI performance and report any inappropriate responses</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">6. Compliance with US and EU AI Regulations</h2>
          <p className="text-gray-600 mb-4">
            You agree to comply with all applicable AI-related regulations, including but not limited to:
          </p>
          <ul className="list-disc pl-6 text-gray-600 space-y-2">
            <li>The EU AI Act and related European legislation</li>
            <li>US federal and state AI disclosure requirements</li>
            <li>TCPA (Telephone Consumer Protection Act) regulations</li>
            <li>HIPPA, GDPR, CCPA, and other applicable data protection regulations</li>
            <li>Requirements to disclose AI usage to callers when applicable</li>
            <li>Maintaining appropriate records of AI engagements as required by law</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">7. Limitation of Liability</h2>
          <p className="text-gray-600 mb-4">
            AI Phone Agent shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to:
          </p>
          <ul className="list-disc pl-6 text-gray-600 space-y-2">
            <li>Any inaccurate information generated by the AI system</li>
            <li>Business losses due to AI limitations or misunderstandings</li>
            <li>Regulatory penalties resulting from your use of our AI systems</li>
            <li>Any damages resulting from misuse of the service</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">8. Changes to Terms</h2>
          <p className="text-gray-600">
            We reserve the right to modify these terms at any time. Continued use of the service constitutes acceptance of modified terms.
          </p>
        </section>
      </div>
    </div>
  );
}